
import React, { useContext } from "react";
import { Context } from "../context/ProductsProvider";
import UploadProductForm from "./UploadProductForm";
import "../App.css";

const AddNewItem = () => {
  const { dispatch, state } = useContext(Context);
  const toggle = (bool) => dispatch({ type: "collapse", payload: { bool } });
  return (
    <>
      <button
        className="btn float-start btn_add"
        onClick={() => toggle(!state.isCollapsed)}
      >
        {state.isCollapsed ? "Close" : "+ Add new item"}
      </button>
      <div className="clearfix mb-4"></div>
      <UploadProductForm inputs={state.inputs} isVisible={state.isCollapsed} />
    </>
  );
};

export default AddNewItem;
